module.exports = __webpack_public_path__ + "static/media/Hero_canada.41b74fcf.avif";